import {
  Backdrop,
  Box,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { filter, find, join, map, split, tail } from 'lodash';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import departmentService from '../../services/departmentService';
import eventService from '../../services/eventService';

const EventDepartment = () => {
  const [selectedEvent, setSelectedEvent] = useState('');
  const [departments, setDepartments] = useState([]);
  const [assignedDepartments, setAssignedDepartments] = useState([]);
  const [events, setEvents] = useState([]);
  const [qrCodeList, setQRCodeList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleEventChange = (event) => {
    setSelectedEvent(event.target.value);
    setAssignedDepartments([]);
  };

  // const qrcode = async (data) => {
  //   setLoading(true);
  //   const res = await departmentService?.codeGenerator(data);
  //   setLoading(false);
  //   if (res?.status === 200) {
  //     return `https://procam.pythonanywhere.com/${join(
  //       tail(split(res?.data, 'webapi')),
  //       'webapi'
  //     )}`;
  //   }
  // };

  const handleCheckboxChange = async (departmentId, data) => {
    setLoading(true);
    if (assignedDepartments.includes(departmentId)) {
      // Unchecking the checkbox
      setAssignedDepartments((prev) =>
        prev.filter((id) => id !== departmentId)
      );
      setDepartments((prevDepartments) =>
        prevDepartments.map((dept) =>
          dept.id === departmentId ? { ...dept, qrcode: null } : dept
        )
      );

      const findItemId = find(
        qrCodeList,
        (data) =>
          data?.event_id === selectedEvent &&
          data?.department_id === departmentId
      )?.id;

      if (findItemId) {
        // Call API to delete department assignment
        await eventService?.removeDepartmentAssignment(findItemId);
        toast.success(`Station unassigned successfully`);
        getDepartments();
      }
    } else {
      // Checking the checkbox
      // const qrCode = await qrcode(data); // Generate QR code
      setAssignedDepartments((prev) => [...prev, departmentId]);
      setDepartments((prevDepartments) =>
        prevDepartments.map((dept) =>
          dept.id === departmentId ? { ...dept } : dept
        )
      );

      // Call API to add department assignment
      await eventService?.assignDepartments([
        {
          event_id: selectedEvent,
          department_id: departmentId,
          // qrcode: qrCode,
        },
      ]);
      toast.success(`Station assigned successfully`);
      getDepartments();
    }
    setLoading(false);
  };

  const fetchDepartment = async () => {
    setLoading(true);
    const response = await departmentService.getDepartments();
    setDepartments(response.data);
    setLoading(false);
  };

  const fetchEvent = async () => {
    setLoading(true);
    const response = await eventService.getEvents();
    setEvents(filter(response.data, { active: true }));
    setLoading(false);
  };

  useEffect(() => {
    fetchDepartment();
    fetchEvent();
  }, []);

  const getDepartments = async () => {
    setLoading(true);
    const res = await eventService?.getEventsDepartments();
    if (res?.status === 200) {
      setQRCodeList(
        filter(res?.data, (data) => data?.event_id === parseInt(selectedEvent))
      );
      setAssignedDepartments(
        map(
          filter(res?.data, { event_id: parseInt(selectedEvent) }),
          (data) => data?.department_id
        )
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    if (selectedEvent) {
      getDepartments();
    }
  }, [selectedEvent]);

  return (
    <LayoutContainer>
      <AdminHeader title='Event Stations' />
      <div className='page-content-wrapper scrollable'>
        <Card>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <FormControl fullWidth>
                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                  Select Event
                </Typography>
                <Select
                  value={selectedEvent}
                  onChange={handleEventChange}
                  sx={{ width: 'auto' }}
                >
                  {events.map((event) => (
                    <MenuItem key={event?.id} value={event?.id}>
                      {event?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </CardContent>
        </Card>
        {selectedEvent && (
          <Table className='table'>
            <TableHead className='tableHead'>
              <TableRow>
                <TableCell>Assign</TableCell>
                <TableCell>Station</TableCell>
                {/* <TableCell>QR Code</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody className='tableBody'>
              {departments.map((department, index) => (
                <TableRow
                  key={department.id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                    // '&:hover': { backgroundColor: '#e0f7fa' },
                  }}
                >
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={assignedDepartments.includes(department.id)}
                          onChange={() =>
                            handleCheckboxChange(department.id, {
                              department_name: `Station Name: ${department?.name} Contact Name: ${department?.contact_name} Contact Number: ${department?.contact_number}`,
                              filename: `${department.name}${
                                find(events, { id: selectedEvent })?.name
                              }.png`,
                            })
                          }
                        />
                      }
                      label=''
                    />
                  </TableCell>
                  <TableCell>{department.name}</TableCell>
                  {/* <TableCell>
                    {department?.qrcode ||
                    find(qrCodeList, { department_id: department?.id }) ? (
                      <a
                        href={
                          department?.qrcode ||
                          find(qrCodeList, { department_id: department?.id })
                            ?.qrcode
                        }
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <img
                          src={
                            department?.qrcode ||
                            find(qrCodeList, { department_id: department?.id })
                              ?.qrcode
                          }
                          alt='QR Code'
                          style={{
                            width: '40px',
                            height: 'auto',
                            cursor: 'pointer',
                          }}
                        />
                      </a>
                    ) : (
                      '-'
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>

      {/* Backdrop for loading state */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </LayoutContainer>
  );
};

export default EventDepartment;

// import React, { useEffect, useState } from 'react';
// import {
//   Select,
//   MenuItem,
//   Checkbox,
//   FormControlLabel,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   Button,
//   Alert,
//   Snackbar,
// } from '@mui/material';
// import {
//   filter,
//   find,
//   includes,
//   isEmpty,
//   join,
//   map,
//   split,
//   tail,
//   uniq,
// } from 'lodash';
// import eventService from '../../services/eventService';
// import departmentService from '../../services/departmentService';
// import LayoutContainer from '../../components/LayoutContainer';
// import AdminHeader from '../../components/AdminHeader';
// import { toast } from 'react-toastify';

// const EventDepartment = () => {
//   const [selectedEvent, setSelectedEvent] = useState('');
//   const [departments, setDepartments] = useState([]);
//   const [assignedDepartments, setAssignedDepartments] = useState([]);
//   const [events, setEvents] = useState([]);
//   const [qrCodeList, setQRCodeList] = useState([]);

//   const handleEventChange = (event) => {
//     setSelectedEvent(event.target.value);
//     setAssignedDepartments([]); // Reset assigned departments when the event changes
//   };

//   const qrcode = async (data) => {
//     const res = await departmentService?.codeGenerator(data);
//     if (res?.status === 200) {
//       return https://verify360procam.pythonanywhere.com${join(
//         tail(split(res?.data, 'vproapp')),
//         'vproapp'
//       )}; // Assuming the QR code URL is returned in this format
//     }
//   };

//   const handleCheckboxChange = async (departmentId, data) => {
//     if (assignedDepartments.includes(departmentId)) {
//       setAssignedDepartments((prev) =>
//         prev.filter((id) => id !== departmentId)
//       );
//       setDepartments((prevDepartments) =>
//         prevDepartments.map((dept) =>
//           dept.id === departmentId ? { ...dept, qrcode: null } : dept
//         )
//       );
//     } else {
//       const qrCode = await qrcode(data); // Generate QR code
//       setAssignedDepartments((prev) => [...prev, departmentId]);
//       setDepartments((prevDepartments) =>
//         prevDepartments.map((dept) =>
//           dept.id === departmentId ? { ...dept, qrcode: qrCode } : dept
//         )
//       );
//     }
//   };

//   const fetchDepartment = async () => {
//     const response = await departmentService.getDepartments();
//     setDepartments(response.data);
//   };

//   const fetchEvent = async () => {
//     const response = await eventService.getEvents();
//     setEvents(response.data);
//   };

//   useEffect(() => {
//     fetchDepartment();
//     fetchEvent();
//   }, []);

//   const getDepartments = async () => {
//     const res = await eventService?.getEventsDepartments();
//     if (res?.status === 200) {
//       console.log('res', res);
//       setQRCodeList(res?.data);
//       setAssignedDepartments(
//         map(
//           filter(res?.data, { event_id: parseInt(selectedEvent) }),
//           (data) => data?.department_id
//         )
//       );
//     }
//   };

//   useEffect(() => {
//     // if () {
//     getDepartments();
//     // }
//   }, []);

//   console.log('departments', departments, assignedDepartments);

//   const handleSubmit = async () => {
//     const response = await eventService?.assignDepartments(
//       map(uniq(assignedDepartments), (department_id) => {
//         const department = departments.find(
//           (dept) => dept.id === department_id
//         );
//         return {
//           event_id: selectedEvent,
//           department_id: department_id,
//           qrcode: department?.qrcode || '',
//         };
//       })
//     );

//     console.log(
//       '=====',
//       map(uniq(assignedDepartments), (department_id) => {
//         const department = departments.find(
//           (dept) => dept.id === department_id
//         );
//         return {
//           event_id: selectedEvent,
//           department_id: department_id,
//           qrcode: department?.qrcode || '',
//         };
//       })
//     );

//     if (response?.status === 201) {
//       toast.success('Department added successfully');
//     }
//   };

//   return (
//     <LayoutContainer>
//       <AdminHeader title='Event Department' />
//       <div className='page-content-wrapper scrollable'>
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//           <FormControl fullWidth>
//             <Typography>Select Event</Typography>
//             <Select
//               value={selectedEvent}
//               onChange={handleEventChange}
//               sx={{ width: 'auto' }}
//             >
//               {events.map((event) => (
//                 <MenuItem key={event?.id} value={event?.id}>
//                   {event?.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//           <Button
//             onClick={handleSubmit}
//             variant='contained'
//             disabled={isEmpty(assignedDepartments)}
//           >
//             Submit
//           </Button>
//         </Box>
//         {selectedEvent && (
//           <Table className='table'>
//             <TableHead className='tableHead'>
//               <TableRow>
//                 <TableCell>Department</TableCell>
//                 <TableCell>QR Code</TableCell>
//                 <TableCell>Assign</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody className='tableBody'>
//               {departments.map((department) => (
//                 <TableRow key={department.id}>
//                   <TableCell>{department.name}</TableCell>
//                   <TableCell>
//                     {department?.qrcode ||
//                     find(qrCodeList, { department_id: department?.id }) ? (
//                       <a
//                         href={
//                           department?.qrcode ||
//                           find(qrCodeList, { department_id: department?.id })
//                             ?.qrcode
//                         }
//                         target='_blank'
//                         rel='noopener noreferrer'
//                       >
//                         <img
//                           src={
//                             department?.qrcode ||
//                             find(qrCodeList, { department_id: department?.id })
//                               ?.qrcode
//                           }
//                           alt='QR Code'
//                           style={{
//                             width: '40px',
//                             height: 'auto',
//                             cursor: 'pointer',
//                           }}
//                         />
//                       </a>
//                     ) : (
//                       '-'
//                     )}
//                   </TableCell>
//                   <TableCell>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={
//                             assignedDepartments.includes(department.id) ||
//                             find(qrCodeList, { department_id: department?.id })
//                           }
//                           onChange={() =>
//                             handleCheckboxChange(department.id, {
//                               department_name: {
//                                 department_name: department.name,
//                                 contact_person: department.contact_name,
//                                 contact_number: department.contact_number,
//                               },
//                               filename: ${department.name}${
//                                 find(events, { id: selectedEvent })?.name
//                               }.png,
//                             })
//                           }
//                         />
//                       }
//                       label=''
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         )}
//       </div>
//     </LayoutContainer>
//   );
// };

// export default EventDepartment;
